module.exports = isWidget

function isWidget(w) {
    return w && w.type === "Widget"
}



// WEBPACK FOOTER //
// ./node_modules/virtual-dom/vnode/is-widget.js